export default __webpack_public_path__ + "static/media/topArrow.e9091522.svg";